import styled from 'styled-components';

export const Container = styled.section``;

export const Form = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  textarea {
    width: 100%;
    height: 80px;
    margin-top: 12px;
    font-size: 16px;
    padding: 12px;
    border-radius: 8px;
    border: 0;
    resize: none;
  }
`;

export const Bubble = styled.label`
  width: 100%;
  display: flex;
  margin: 4px 0;
  padding: 12px;
  background-color: ${({ theme }) => theme.colors.grey[700]};
  color: ${({ $checked, theme }) =>
    $checked ? theme.colors.primary.main : theme.colors.grey.white};
  border: 1px solid
    ${({ $checked, theme }) =>
      $checked ? theme.colors.primary.main : theme.colors.grey[800]};
  border-radius: 4px;
  cursor: pointer;

  &:hover {
    transition: 0.7s;
    opacity: 0.8;
  }
`;

export const Button = styled.button`
  width: fit-content;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Bebas Neue', sans-serif;
  border-radius: 28px;
  color: ${({ theme }) => theme.colors.grey.white};
  background-color: ${({ theme }) => theme.colors.grey.black};
  font-size: 32px;
  font-weight: 400;
  margin: 0 auto;
  border: 0;
  padding: 12px 36px 6px 36px;

  @media ${({ theme }) => theme.devices.mobile} {
    font-size: 20px;
  }

  &:hover {
    transition: 0.7s;
    background-color: ${({ theme }) => theme.colors.grey[700]};
  }
`;

export const ButtonContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 20px;

  button {
    width: 100%;
    border: none;
    padding: 12px 20px;
    border-radius: 8px;
    cursor: pointer;

    &:hover {
      transition: 0.7s;
      opacity: 0.7;
    }
  }
`;

export const SubmitButton = styled.button`
  background-color: ${({ theme }) => theme.colors.primary.main};
  color: ${({ theme }) => theme.colors.grey.white};
`;

export const CancelButton = styled.button`
  padding: 0 !important;
  background-color: transparent;
  color: ${({ theme }) => theme.colors.grey.white};
`;
